const dataActions = {
  CHANGE: 'DATA_CHANGE',
  CHANGE_AUTO_COMPLETE: 'DATA_CHANGE_AUTO_COMPLETE',
  CHANGE_LISTGROUP: 'DATA_CHANGE_LISTGROUP',

  changeAutoComplete: (key, option) => ({
    payload: {
      key,
      option,
    },
    type: dataActions.CHANGE_AUTO_COMPLETE,
  }),
  changeData: (key, value) => ({
    payload: {
      key,
      value,
    },
    type: dataActions.CHANGE,
  }),
  changeListGroupData: (listGroupName, listIndex, key, value) => ({
    payload: {
      key,
      listGroupName,
      listIndex,
      value,
    },
    type: dataActions.CHANGE_LISTGROUP,
  }),
};

export default dataActions;
